import { render } from "./SegmentControls.vue?vue&type=template&id=0a89d878&scoped=true&ts=true"
import script from "./SegmentControls.vue?vue&type=script&lang=ts"
export * from "./SegmentControls.vue?vue&type=script&lang=ts"

import "./SegmentControls.vue?vue&type=style&index=0&id=0a89d878&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a89d878"]])

export default __exports__